<!-- =========================================================================================
    File Name: CollapseDefault.vue
    Description: Rendering of default collapse
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <vx-card title="Editar Perfil (Informações Básicas)" code-toggler>

        <p>Você pode editar informações essenciais como: <code>Plano, Pin, Email entre outros.</code> Toda alteração é necessário <code>confirmar no seu email.</code></p>

        <div class="mt-5">

            <vs-collapse>

                <vs-collapse-item>

                    <div slot="header">
						<div class="collapse-header">
						<div id="headingCollapse1">
						  <div class="lead collapse-title collapsed">
							<div class="media">
								<a class="media-left" href="#" style="margin-left: 22px;">
									<img v-if="activeUserImg.startsWith('http')" class="rounded-circle mr-2" :src="activeUserImg" alt="Generic placeholder image" height="64" width="64">
									<img v-else class="rounded-circle mr-2" :src="require(`@/assets/images/portrait/small/${activeUserImg}`)" alt="Generic placeholder image" height="64" width="64">
								</a>
								<div class="media-body mt-1" style="margin-left: 20px;">
								 <h5 class="media-heading mb-0" >{{dadosx.nome}} (@{{dadosx.login}})</h5>
								  <a class="text-muted" href="#"><small>{{dadosx.email_candidato}}</small></a>
								</div>
							</div>
						  </div>
						</div>
						</div>
					</div>

				<div class="vx-row mb-2">
					  <div class="vx-col w-full">
						<vs-input class="w-full" icon-pack="feather" icon="icon-user" icon-no-border label="Nome Completo" v-model=dadosx.nome />
					  </div>
					</div>
					<div class="vx-row mb-2">
					  <div class="vx-col w-full">
						<vs-input type="email" class="w-full" icon-pack="feather" icon="icon-mail" disabled icon-no-border label="Email" v-model="dadosx.email_candidato" />
					  </div>
					</div>
					<div class="vx-row mb-2">
					  <div class="vx-col w-full">
						<vs-input class="w-full" icon-pack="feather" icon="icon-smartphone" icon-no-border label="Telefone Celular" v-model="dadosx.telefone_celular" />
					  </div>
					</div>
					<div class="vx-row mb-2">
					  <div class="vx-col w-full">
						<vs-input class="w-full" icon-pack="feather" icon="icon-smartphone" disabled icon-no-border label="Data de Nascimento" v-model="dadosx.data_nascimento" />
					  </div>
					</div>
                    <div class="vx-row mb-2">
					  <div class="vx-col w-full">
						<vs-input class="w-full" v-mask="'#####-###'" v-validate="'required|min:9'" icon-pack="feather" icon="icon-smartphone" icon-no-border label="CEP" v-model="dadosx.cep" />
					  </div>
					</div>
					<div class="vx-row mb-2">
					  <div class="vx-col w-full">
						<vs-input class="w-full" icon-pack="feather" icon="icon-smartphone" disabled icon-no-border label="CPF/CNPJ" v-model="dadosx.cpf" />
					  </div>
					</div>
					<div class="vx-row mb-2">
					  <div class="vx-col w-full">
						<vs-input class="w-full" icon-pack="feather" icon="icon-user" icon-no-border label="Referido" v-model="dadosx.referido" />
					  </div>
					</div>

					<vs-alert color="primary" icon="new_releases" active="true" class="mt-1">
                      Adicione a foto de perfil no campo abaixo
                  </vs-alert>

                  <div class="mt-1">
                      <vs-upload limit="1" :action="url_contrato" @on-success="successUpload" @on-error="errorUpload" />
                  </div>

					<div class="vx-row">
					  <div class="vx-col w-full">
						<vs-button class="mr-3 mb-2" @click="saveData">Salvar</vs-button>
					  </div>
				</div>
				</vs-collapse-item>

            </vs-collapse>

        </div>



    </vx-card>
</template>
<script>
import {mask} from 'vue-the-mask'
export default {
    directives: {
        mask
    },
  methods: {
  	successUpload(retorn) {
            console.log(retorn.target.response);
            var dados = JSON.parse(retorn.target.response);
            this.$vs.notify({ color: 'success', title: 'Status', text: dados.message })
        },
        errorUpload(retorn) {
            console.log(retorn.target.response);
            var dados = JSON.parse(retorn.target.response);
            this.$vs.notify({ color: 'danger', title: 'Status', text: dados.message })
        },
	saveData()
	{
		this.$vs.loading({
			type:'radius',
		})

		fetch(this.$store.state.API_URL + 'Info/Save/Basic', {
			method: 'POST',
			headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
			body: "token="+localStorage.getItem("token")+"&nome="+this.dadosx.nome+"&telefone_celular="+this.dadosx.telefone_celular+"&cep="+this.dadosx.cep+"&referido="+this.dadosx.referido
		})
		.then((response) => response.text())
		.then((responseData) => {
			var dados = JSON.parse(responseData);

			if(dados.done == true)
			{
				this.dadosx = dados.dados;
				setTimeout( ()=> {
					this.$vs.loading.close();
					localStorage.removeItem('userInfo');
					localStorage.setItem('userInfo', JSON.stringify({
						displayName: dados.dados.nome,
						Login: dados.dados.login,
						plan: dados.dados.combo,
						email: dados.dados.email_candidato,
						photoURL: dados.dados.foto_perfil,
						providerId: dados.dados.id,
						uid: dados.dados.id
					}));
					this.$vs.notify({
						title: 'SPSaude',
						text: dados.message,
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'success'
					});
				}, 4000);

			}
			else
			{
				setTimeout( ()=> {
					this.$vs.loading.close();
					this.$vs.notify({
						title: 'SPSaude',
						text: dados.message,
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'warning'
					});

				}, 4000);
			}

		});
	},
  	getPorc(valor){
		if(valor == null)
			return "0.0";
		else
			return valor;
	},
  	getReal(valor){
		if(valor == null)
			return "0,00";
		else
			return valor;
	},
    getOrderStatusColor(status) {
      if(status == 'received') return "success"
      if(status == 'send') return "danger"
      return "primary"
    },
    getOrderText(status) {
      if(status == 'received') return "Crédito"
      if(status == 'send') return "Débito"
      return "primary"
    },
    getPopularityColor(num) {
      if(num > 90) return "success"
      if(num >70) return "primary"
      if(num >= 50) return "warning"
      if(num < 50) return "danger"
      return "primary"
    },
    formatData(data) {
      // formats data received from API
      let formattedData = data.map((item) => {
        const fields = item.fields
        let obj = {}
        for (const key of Object.keys(fields)) {
            obj[key] = fields[key].stringValue || fields[key].integerValue || fields[key].doubleValue;
        }
        return obj
      });
      return formattedData
    }
  },
  created() {
    const thisIns = this;
	fetch(this.$store.state.API_URL + 'Info/Home', {
		method: 'POST',
		headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
		body: "token="+localStorage.getItem("token")
	})
	.then((response) => response.text())
	.then((responseData) => {

		var dados = JSON.parse(responseData);
		thisIns.dadosx = dados.meus_dados;
		this.nome = this.dadosx.nome;

	});
  },
  mounted() {
    this.isMounted = true;
  },
	computed: {
	    user_displayName() {
            return JSON.parse(localStorage.getItem('userInfo')).displayName
        },
		user_displayMail() {
			return JSON.parse(localStorage.getItem('userInfo')).email
		},
		activeUserImg() {
            return JSON.parse(localStorage.getItem('userInfo')).photoURL || this.$store.state.AppActiveUser.img;
        }
	},
    data() {

        return {
			dadosx: [],
			url_contrato: this.$store.state.API_URL+'documentos/upload/profile/'+localStorage.getItem("token"),
        }
    },
}
</script>
<style>
.lead {
    font-size: 1.25rem;
}
.display-1, .display-2, .display-3, .display-4, .lead {
    font-weight: 300;
}
.media {
    display: flex;
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
    -moz-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
}
.rounded-circle {
    border-radius: 50%!important;
}
.media-body {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
}

.text-muted {
    color: #B8C2CC!important;
}
.small, small {
    font-size: smaller;
    font-weight: 400;
}
.text-capitalize {
    text-transform: capitalize!important;
}
</style>
